import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useIsAvaliador = () => {
  const { user } = useAuth();

  const { data: isAvaliador = false } = useQuery({
    queryKey: ['is-avaliador-designado', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('fn_is_avaliador_designado');
      if (error) {
        console.error('[useIsAvaliador] Erro:', error.message);
        return false;
      }
      return data === true;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000,
  });

  return { isAvaliador };
};
